import ToastDialog from "components/Common/ToastDialog";
import { useFormik } from "formik";
import { forgetPassword } from "http/auth/reset";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import * as Yup from "yup";
import lightlogo from "../../assets/images/cashinvoice-white-logo.svg";
import verificationImg from "../../assets/images/5024147-Photoroom.png";
import colorlogo from "../../assets/images/ci_logo.png";

const ForgotPassword = () => {
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [loading, setLoading] = useState(false);
  const validation = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Must be a valid Email")
        .max(255)
        .required("Email is required"),
    }),
    onSubmit: (values) => {
      setLoading(true);
      submit(values.email);
    },
  });

  const submit = (email) => {
    forgetPassword({ email: email })
      .then((res) => {
        setLoading(false);
        if (res.status) {
          setToastInfo({
            message: res.message,
            showToast: true,
            role: "success",
          });
          validation.resetForm();
        } else {
          setToastInfo({
            message: res.message,
            showToast: true,
            role: "error",
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  return (
    <React.Fragment>
      <div className="account-pages account-pages-bg bg-color login-page">
        <Row className="justify-content-center m-auto h-100vh scrollable-height" style={{width:'90%'}}>
          <Col  md={6} xl={8} lg={7} className="d-none d-md-block">
            <div className="left-section h-100">
              <div className="d-flex w-100 justify-content-center">
                <img src={lightlogo} alt="" className="img-fluid ci-logo"  style={{ width: '200px' }}/>
              </div>

              <div className="d-flex justify-content-center w-100  h-100 align-items-center">
                <img
                  src={verificationImg}
                  alt=""
                  className="img-fluid verification-img"
                />
              </div>
            </div>
          </Col>
          <Col
            md={6}
            lg={5}
            xl={4}
            className="form-layout-section m-auto d-flex justify-content-center"
          >
            <div className="d-flex w-100 justify-content-center d-block d-md-none">
              <img src={colorlogo} alt="" className="img-fluid ci-logo" />
            </div>

            <div className="p-2">
              <div className="d-flex flex-column align-items-left">
                <h3 className="mt-3 mb-3 header-reg">Forget Password</h3>
              </div>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <div className="form-floating mb-3">
                  <Input
                    name="email"
                    placeholder="Enter Registered Email"
                    type="email"
                    className="form-control"
                    id="forgotEmail"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email || ""}
                    invalid={
                      validation.touched.email && validation.errors.email
                        ? true
                        : false
                    }
                  />
                  <Label htmlFor="forgotEmail">Email</Label>
                  {validation.touched.email && validation.errors.email ? (
                    <FormFeedback type="invalid">
                      {validation.errors.email}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="w-100 mt-3 d-flex justify-content-center">
                  <Button color="primary" type="submit">
                    {loading && (
                      <span
                        className="spinner-border spinner-border-sm ms-2 me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                    {!loading && <span>Send Reset Link</span>}
                    {loading && <span>Sending...</span>}
                  </Button>
                </div>
              </Form>
            </div>
            <div className="mt-2 text-center">
              <p>
                Remembered?{" "}
                <Link to="/login" className="fw-medium text-primary">
                  Log In
                </Link>
              </p>
            </div>
          </Col>
        </Row>
      </div>

      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

export default ForgotPassword;
